/* eslint-disable jsx-a11y/iframe-has-title */
import React, { useContext, useEffect } from "react";
import { objectiveContext } from "../../context/Objective";
import Vimeo from "@u-wave/react-vimeo";

function HomeBanner() {
  const { setSolutionActive, setCompanyActive } = useContext(objectiveContext);
  useEffect(() => {
    document.getElementById("iframe_da_pawa").setAttribute("width", "100%");
    document.getElementById("iframe_da_pawa").setAttribute("height", "100%");
  });
  return (
    <div className="relative flex flex-col justify-end">
      <div className="h-[60px]"></div>
      <div
        onClick={() => {
          setSolutionActive(false);
          setCompanyActive(false);
        }}
        className="w-full max-[1200px]:h-fit flex items-center flex-col justify-center bg-cover bg-no-repeat bg-center"
      >
        {/* <video width="100%" height="100%" autoPlay loop muted>
          <source src="/assets/video.mp4" type="video/mp4" />
        </video> */}
        <div className="w-full h-full relative">
          <Vimeo
            video="https://player.vimeo.com/video/788773287?h=3fdab82da2&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
            autoplay={true}
            loop={true}
            controls={false}
            responsive={true}
            id="iframe_da_pawa"
          />
        </div>
      </div>
      {/* {width > 991 && (
        <div className="scroll_downs absolute z-[100] bottom-[20px] left-0">
          <div className="mousey">
            <div className="scroller"></div>
          </div>
        </div>
      )} */}
    </div>
  );
}

export default HomeBanner;
